import React from 'react';
import { useNavigate } from 'react-router-dom';
import logoImage from '../assets/images/logonewnobg.png';
import '../styles/TermsAndConditions.css';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  const handleBackToLogin = () => {
    navigate('/login');
  };

  return (
    <div className="terms-container">
      <div className="terms-content">
        {/* Header */}
        <div className="terms-header">
          <div className="terms-logo">
            <img src={logoImage} alt="VReels Shop" className="terms-logo-img" />
          </div>
          <h1 className="terms-title">Terms & Conditions</h1>
          <p className="terms-subtitle">Effective Date: September, 2025</p>
        </div>

        {/* Terms Content */}
        <div className="terms-body">
          <section className="terms-section">
            <h2 className="section-title">1. Introduction</h2>
            <p className="section-content">
              These Vendor Terms govern your use of Vreels Shop as a seller. By registering as a Vendor, you agree to comply with these Terms, our policies, and all applicable laws.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">2. Vendor Eligibility</h2>
            <ul className="section-list">
              <li>You must be at least 18 years old and legally able to conduct business.</li>
              <li>You must provide accurate business, tax, and banking details.</li>
              <li>You are solely responsible for obtaining all licenses, permits, and legal registrations required for your products.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">3. Vendor Obligations</h2>
            <ul className="section-list">
              <li>Ensure that product listings are accurate, lawful, and non-misleading.</li>
              <li>Fulfill orders promptly and maintain high-quality service.</li>
              <li>Respond to buyer inquiries and complaints in a timely manner.</li>
              <li>Comply with prohibited and restricted product policies.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">4. Fees & Payments</h2>
            <ul className="section-list">
              <li>We charge commissions and/or service fees on sales as specified in our fee schedule (will be published at a later date).</li>
              <li>Payouts will be made after deducting applicable fees and commissions.</li>
              <li>Vendors are responsible for paying all applicable taxes.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">5. Shipping & Delivery</h2>
            <ul className="section-list">
              <li>Vendors must ship within the promised timeline.</li>
              <li>Vendors are responsible for lost or damaged goods until delivery is confirmed.</li>
              <li>Tracking details must be provided when applicable.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">6. Returns & Refunds</h2>
            <ul className="section-list">
              <li>Vendors must honor their published return/refund policy.</li>
              <li>If no policy is provided, our default policy applies.</li>
              <li>Vendors are responsible for processing refunds in a timely manner.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">7. Intellectual Property</h2>
            <ul className="section-list">
              <li>Vendors retain ownership of their content but grant us a license to use it for marketing and display.</li>
              <li>Vendors must not infringe on third-party rights.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">8. Compliance & Liability</h2>
            <ul className="section-list">
              <li>Vendors must comply with consumer protection, data privacy, and e-commerce regulations.</li>
              <li>Vendors are liable for their products and indemnify us against claims arising from their business.</li>
            </ul>
          </section>

          <section className="terms-section">
            <h2 className="section-title">9. Termination</h2>
            <p className="section-content">
              We reserve the right to suspend or remove any Vendor account for violations of these Terms or fraudulent activity.
            </p>
          </section>

          <section className="terms-section">
            <h2 className="section-title">10. Contact Us</h2>
            <p className="section-content">
              If you have questions about these Terms and Conditions:
            </p>
            <ul className="section-list">
              <li><strong>Email:</strong> support@vreels.com</li>
              <li><strong>Address:</strong> Maha Naga Kali LLC, DBA Vreels, 204 W J Boaz Rd, Saginaw, TX 76179</li>
            </ul>
          </section>
        </div>

        {/* Footer */}
        {/* <div className="terms-footer">
          <button onClick={handleBackToLogin} className="btn btn-primary back-to-login-btn">
            Back to Login
          </button>
        </div> */}
      </div>
    </div>
  );
};

export default TermsAndConditions;
